import { useState, useEffect } from "react";

const RescheduleModal = ({
  isOpen,
  onClose,
  onSubmit,
  selectedAppointment,
  actionLoading
}) => {
  const [newDate, setNewDate] = useState('');
  const [newTime, setNewTime] = useState('');

  useEffect(() => {
    if (selectedAppointment) {
      setNewDate(selectedAppointment.date?.slice(0, 10) || '');
      setNewTime(selectedAppointment.time || '');
    }
  }, [selectedAppointment]);

  if (!isOpen) return null;

  const handleSubmit = () => {
    const isValidDate = /^\d{4}-\d{2}-\d{2}$/.test(newDate);
    const isValidTime = /^([0-1]\d|2[0-3]):([0-5]\d)$/.test(newTime);
    if (!isValidDate || !isValidTime) {
      alert("Invalid date or time format.");
      return;
    }

    const today = new Date();
    const selected = new Date(newDate);
    today.setHours(0, 0, 0, 0);
    selected.setHours(0, 0, 0, 0);

    const maxDate = new Date();
    maxDate.setDate(today.getDate() + 10);
    maxDate.setHours(0, 0, 0, 0);

    if (selected < today || selected > maxDate) {
      alert("Please select a date between today and the next 10 days.");
      return;
    }

    onSubmit({ date: newDate, time: newTime });
    onClose();
  };

  // Format today's date and max date for input attributes
  const minDate = new Date().toISOString().split("T")[0];
  const maxDate = new Date(Date.now() + 10 * 24 * 60 * 60 * 1000)
    .toISOString()
    .split("T")[0];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg p-6 w-80 shadow-lg">
        <h3 className="text-xl font-semibold mb-4">Reschedule Appointment</h3>
        <label className="block mb-2">
          New Date:
          <input
            type="date"
            value={newDate}
            min={minDate}
            max={maxDate}
            onChange={(e) => setNewDate(e.target.value)}
            className="w-full border border-gray-300 rounded px-2 py-1"
          />
        </label>
        <label className="block mb-4">
          New Time:
          <input
            type="time"
            value={newTime}
            onChange={(e) => setNewTime(e.target.value)}
            className="w-full border border-gray-300 rounded px-2 py-1"
          />
        </label>
        <div className="flex justify-end space-x-4">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={actionLoading === selectedAppointment?.appointmentId}
            className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
          >
            {actionLoading === selectedAppointment?.appointmentId ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RescheduleModal;
